// Shop tab: the categories as "Coming soon" tiles until the catalogue lands (005).
import { ShopScreen } from "@/home/ShopScreen";

export default function Shop() {
  return <ShopScreen />;
}
